import session from 'app/_shared/session'

/**
 * Returns the ref of `item`, if it has one.
 *
 * @param {Object} item     the item to return the ref from
 * @returns {*|undefined}   either the ref of the item or undefined
 */
const ref = item => item?.[0]?.key || undefined

/**
 * Returns either the key of `item` or the values that should correspond to the currently
 * selected static filters.
 *
 * @param {Gaia.AppModule.Spec} module the ticket module composition object
 * @param {Object} item     the item to return the ref from
 * @returns {*|undefined}   either the ref of the item or undefined
 */
export default (module, item) => {
  const key = ref(item)
  const meKey = key === 'me' ? session(module).user.key() : key
  const noneMeKey = key === 'none' ? [] : meKey
  return !key || key === 'any' ? undefined : noneMeKey
}
